import { render, staticRenderFns } from "./RequestServiceObject.vue?vue&type=template&id=00bba22d&scoped=true"
import script from "./RequestServiceObject.vue?vue&type=script&lang=js"
export * from "./RequestServiceObject.vue?vue&type=script&lang=js"
import style0 from "./RequestServiceObject.vue?vue&type=style&index=0&id=00bba22d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bba22d",
  null
  
)

export default component.exports